var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.188 1.203C9.384-.074 8.1-.047 7.612.03a.514.514 0 0 0-.333.207l-4.4 5.904L.722 9.033a2.227 2.227 0 0 0-.44 1.21L0 15.454c-.02.375.364.646.724.512l5.006-1.862c.422-.157.789-.43 1.053-.786l1.757-2.357 4.796-6.437a.508.508 0 0 0 .096-.391c-.08-.488-.464-1.67-2.245-2.93Zm-5.442 11.86-1.946.73a.184.184 0 0 1-.21-.057 4.841 4.841 0 0 0-1.024-.954 5.017 5.017 0 0 0-1.248-.654.178.178 0 0 1-.12-.178l.116-2.025.523-.7s1.17-.156 2.698.925c1.526 1.08 1.735 2.212 1.735 2.212l-.524.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6e5aa5eada80261bb1b5c538416decea.svg";
export { ForwardRef as ReactComponent };